/** Display helpers for Created by / Updated by columns on ERP grids. */

export function formatAuditUser(u) {
  if (!u) return '—';
  const n = [u.first_name, u.last_name].filter(Boolean).join(' ').trim();
  return n || u.email || '—';
}

export function formatAuditDate(iso) {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' });
  } catch {
    return '—';
  }
}

/** Standard audit columns (expects API rows with creator, updater, created_at, updated_at). */
export function standardAuditColumns() {
  return [
    {
      field: '_createdBy',
      headerName: 'Created by',
      width: 130,
      sortable: false,
      valueGetter: (p) => formatAuditUser(p.row.creator)
    },
    {
      field: '_createdAt',
      headerName: 'Created date',
      width: 155,
      sortable: false,
      valueGetter: (p) => formatAuditDate(p.row.created_at)
    },
    {
      field: '_updatedBy',
      headerName: 'Updated by',
      width: 130,
      sortable: false,
      valueGetter: (p) => formatAuditUser(p.row.updater)
    },
    {
      field: '_updatedAt',
      headerName: 'Updated date',
      width: 155,
      sortable: false,
      valueGetter: (p) => formatAuditDate(p.row.updated_at)
    }
  ];
}
